module.exports = __webpack_public_path__ + "img/40_38_037_430.09a0114c.jpg";